<div [id]="chartId" [style.height.px]="chartHeight" style="width: 100%;"></div>